import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk, RootState } from '../..'
import { VerticalListState, VerticalListPayload, Filter, CategoryListState, CategoryListPayload } from './models'
import { getBusinessCategoryList, getBusinessVerticalsList } from 'api/businessCategory'

export const initialVerticalList: VerticalListState = {
    data: [],
    meta: {
        page: 1,
        pageCount: 1,
        limit: 20,
    },
    filter: {
        pageSize: 20,
        page: 1,
    },
    isLoading: false,
    hasError: false,
}

const verticalListSlice = createSlice({
    name: 'verticalListSlice',
    initialState: initialVerticalList,
    reducers: {
        requestVerticalList(state) {
            return { ...state, isLoading: true, hasError: false }
        },
        requestedVerticalListFailed(state) {
            return { ...state, isLoading: false, hasError: true }
        },
        receivedVerticalList(state, action: PayloadAction<VerticalListPayload>) {
            const { data, filter, meta } = action.payload
            const newFilter: Filter = {
                ...state.filter,
                ...filter,
            }
            return { ...state, data, meta, filter: newFilter, isLoading: false, hasError: false }
        },
    },
})

export const { requestVerticalList, requestedVerticalListFailed, receivedVerticalList } =
    verticalListSlice.actions

export const fetchVerticalList =
    (filter?: Filter): AppThunk =>
        async dispatch => {
            dispatch(requestVerticalList())
            try {
                const response = await getBusinessVerticalsList(filter)
                if (response) {
                    const { results: data, ...meta } = response.data

                    dispatch(
                        receivedVerticalList({
                            data,
                            filter,
                            meta
                        })
                    )
                }
            } catch (error) {
                dispatch(requestedVerticalListFailed())
            }
        }


export const initialCategoryList: CategoryListState = {
    data: [],
    meta: {
        page: 1,
        pageCount: 1,
        limit: 20,
    },
    filter: {
        pageSize: 20,
        page: 1,
    },
    isLoading: false,
    hasError: false,
}

const categoryListSlice = createSlice({
    name: 'categoryListSlice',
    initialState: initialCategoryList,
    reducers: {
        requestCategoryList(state) {
            return { ...state, isLoading: true, hasError: false }
        },
        requestedCategoryListFailed(state) {
            return { ...state, isLoading: false, hasError: true }
        },
        receivedCategoryList(state, action: PayloadAction<CategoryListPayload>) {
            const { data, filter, meta } = action.payload
            const newFilter: Filter = {
                ...state.filter,
                ...filter,
            }
            return { ...state, data, meta, filter: newFilter, isLoading: false, hasError: false }
        },
    },
})

export const { requestCategoryList, requestedCategoryListFailed, receivedCategoryList } =
    categoryListSlice.actions

export const fetchCategoryList =
    (filter?: Filter): AppThunk =>
        async dispatch => {
            dispatch(requestCategoryList())
            try {
                const response = await getBusinessCategoryList(filter)
                if (response) {
                    const { results: data, ...meta } = response.data
                    dispatch(
                        receivedCategoryList({
                            data,
                            filter,
                            meta
                        })
                    )
                }
            } catch (error) {
                dispatch(requestedCategoryListFailed())
            }
        }

export const selectCategoryList = (state: RootState) => state.businessCategoriesList
export const selectVerticalList = (state: RootState) => state.verticalsList

export const verticalListReducer = verticalListSlice.reducer
export const categoryListReducer = categoryListSlice.reducer

export default {
    verticalsList: verticalListReducer,
    categoriesList: categoryListReducer
}